const en_locales = {
  BANNER_TEXT: "White Label Jamstack Development Agency",
  BANNER_DESCRIPTION: ` We use cutting-edge Jamstack Development to build 
                 high-performing, modern marketing websites for SMEs and corporates.`,
  BANNER_BOTTOM_TEXT: `Hire Your Remote White Label Jamstack Development Team in Just a Few Minutes.
                         No Contract. Flat Monthly Rate. Cancel Anytime. 100% Satisfaction Guaranteed.`,

  CASESTUDY_MINITITLE: `-- JAMSTACK FEATURED CASE STUDY --`,
  CASESTUDY_MAINTITLE: `Wordpress to Jamstack conversion`,
  CASESTUDY_RIGHT_HEADER: `VOLZ - The project we are most proud of`,
  CASESTUDY_RIGHT_TEXT_PRIMARY: `Their website and brand, however, was last updated in 2012. The site was built on a legacy Wordpress tech stack where content became unmanageable over time. Users were interacting with a slow, buggy, outdated website.`,
  CASESTUDY_RIGHT_TEXT_SECONDARY: `Jamstacky developed a high-speed and mobile-friendly platform that met all Jamstack project requirements. The team was flexible and solved problems quickly.`,

  FOOTER_COPYRIGHT: `jamstacky.com © 2022`,
  FOOTER_MAIL: `lets-chat@getconverted.co`,

  INTROCALL_HEADER: `Let’s supercharge your online presence!`,
  INTROCALL_TEXT_PRIMARY: `Be it capture more leads, increase sales or engage visitors with your content, your website must serve your specific business needs. That’s why our approach at Converted is to start by really understanding what it is you want from your site, and perhaps throwing in a few suggestions along the way.`,
  INTROCALL_TEXT_SECONDARY:
    "If, and only if, we think Converted can add value and be ROI-positive for you, we will engage further with a project proposal. Read more about our philosophy and approach here.",

  HOMEBLOG_HEADER: `-- Our Blog --`,
  HOMEBLOG_PRIMARY: `Our clients value our focus on business results and a smooth development process`,
  HOMEBLOG_COL_AUTHOR: `By John Doe `,
  HOMEBLOG_COL_POST_DATE: `Aug 23, 2021`,
  HOMEBLOG_COL_POST_TITLE: `A UX Case Study Creating a Studious Environment for Students: `,
  HOMEBLOG_COL_POST_DESCRIPTION: `Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident.`,

  EDGECASESTUDY_HEADER: `EDGE CASE STUDY`,
  EDGECASESTUDY_PRIMARY: `Maximum performance. With no flickering.`,
  EDGECASESTUDY_RIGHT_HEADER: `We're here to guide and help you at all times`,
  EDGECASESTUDY_RIGHT_TEXT_PRIMARY: `Having to deal with the flickering produced by client side A/B testing apps used to be a necessary pain. But now it is over! The combination of Optimizely Full Stack and Cloudflare Workers Edge technology grants a seamless and fast user experience while maintaining tracking and reporting as accurately as it can be.`,

  TESTIMONIALS_MINI_TITLE: `TESTIMONIALS`,
  TESTIMONIALS_HEADER: `What people say about our blog`,
  TESTIMONIALS_DESCRIPTION_TEXT: `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor.`,
  TESTIMONIALS_MAIN_CONTENT: `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.`,

  TECHNOLOGY_HEADER: `Technology we work with`,
  TECHNOLOGY_PRIMARY: `Your Choice of App Stack`,
  TECHNOLOGY_HEADLESS: `HEADLESS CMS`,
  TECHNOLOGY_SSG: `STATIC SITE GENERATORS`,
  TECHNOLOGY_DEPLOYMENT: `DEPLOYMENT PLATFORM`,

  SERVICE_UNAVAILABLE: `Sorry, this service is currently unavailable.`,
  SUBMIT_UPPER: `SUBMIT`,
  SUBMIT_LOWER: `submit`,
  SUBMIT_MIXED: `Submit`,
  ERROR_URL: `Please provide a valid URL!`,

  THANK_YOU: "Thank You.",
  SHARE: "Share",
  SUBSCRIBE: "Subscribe",
  VIEW_ALL: "View All",
  MOST_POPULAR: "Popular",
  CHOOSE_PLAN: "Choose Plan",

  LOADING: "Loading... ",
READ_MORE:"Read More >",
  SORRY: "Sorry!",
  BLOG_NOT_FOUNDTEXT: "There Is No Blog Of This Topic",
  BLOG_NOT_FOUND_DESCRIPTION:
    "We Will Add New Blog On This Topic Till then you can check our featured post!",
};
export default en_locales as
  | Record<keyof typeof en_locales, string>
  | Record<string, string>;
